var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/codebuild/output/src2118274201/src/tv-monitor-ui/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/js/view/components/DisplayCollectionItemView.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<h4 class=\"list-group-item-heading\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "displayName"), env.opts.autoescape);
output += "</h4>\n<p class=\"list-group-item-text\">\n    <b>\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"listings")),"all")) {
output += "\n            All\n        ";
;
}
else {
output += "\n            ";
output += runtime.suppressValue(env.getFilter("length").call(context, runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"listings")),"selected")), env.opts.autoescape);
output += "\n        ";
;
}
output += "\n    </b>\n    experiences selected\n</p>\n<p class=\"list-group-item-text\">\n    Showing <b>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"capacity"), env.opts.autoescape);
output += "</b> events\n</p>\n<p class=\"list-group-item-text\">\n    <b>\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "config")),"events")),"showGuides")) {
output += "\n            Showing\n        ";
;
}
else {
output += "\n            Not showing\n        ";
;
}
output += "\n    </b>\n    guides\n</p>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/js/view/components/DisplayCollectionItemView.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/js/view/components/DisplayCollectionItemView.njk
// module id = 233
// module chunks = 0